import { render, staticRenderFns } from "./data.vue?vue&type=template&id=5983419e&scoped=true"
import script from "./data.vue?vue&type=script&lang=ts"
export * from "./data.vue?vue&type=script&lang=ts"
import style0 from "./data.vue?vue&type=style&index=0&id=5983419e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5983419e",
  null
  
)

export default component.exports